import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { 
  AcademicCapIcon, 
  UserGroupIcon, 
  BuildingLibraryIcon, 
  BookOpenIcon, 
  GlobeAltIcon,
  StarIcon, 
  UsersIcon, 
  TrophyIcon,
  MapPinIcon,
  EnvelopeIcon,
  PhoneIcon,
  CalendarIcon,
  ClockIcon,
  ChevronRightIcon,
  CheckCircleIcon,
  RocketLaunchIcon,
  HeartIcon,
  LightBulbIcon,
  ShieldCheckIcon,
  SparklesIcon
} from '@heroicons/react/24/outline';
import { StarIcon as StarSolidIcon } from '@heroicons/react/24/solid';

const Home = () => {
  const [showNotice, setShowNotice] = useState(true);
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const stats = [
    { icon: UsersIcon, value: '500+', label: 'Students', color: 'from-blue-500 to-blue-600' },
    { icon: AcademicCapIcon, value: '25+', label: 'Teachers', color: 'from-green-500 to-green-600' },
    { icon: BuildingLibraryIcon, value: '15,000+', label: 'Library Books', color: 'from-purple-500 to-purple-600' },
    { icon: TrophyIcon, value: '100+', label: 'State Ranks', color: 'from-orange-500 to-orange-600' }
  ];

  const features = [
    { 
      icon: BookOpenIcon, 
      title: 'Smart Classes', 
      desc: 'Digital classrooms with interactive learning and smart boards',
      color: 'from-blue-500 to-blue-600'
    },
    { 
      icon: AcademicCapIcon, 
      title: 'Expert Faculty', 
      desc: 'Qualified teachers with years of experience and dedication',
      color: 'from-green-500 to-green-600'
    },
    { 
      icon: GlobeAltIcon, 
      title: 'Global Curriculum', 
      desc: 'Internationally recognized education system with modern approach',
      color: 'from-purple-500 to-purple-600'
    },
    { 
      icon: UserGroupIcon, 
      title: 'Co-curricular', 
      desc: 'Sports, arts, music, and cultural activities for holistic growth',
      color: 'from-orange-500 to-orange-600'
    }
  ];

  const testimonials = [
    {
      name: 'Rahul Sharma',
      role: 'Parent',
      content: 'Vidya Bharati has transformed my child\'s learning experience. The teachers are exceptional.',
      rating: 5,
      avatar: 'https://ui-avatars.com/api/?name=Rahul+Sharma&background=4F46E5&color=fff&size=60'
    },
    {
      name: 'Priya Patel',
      role: 'Student',
      content: 'I love the smart classes and interactive learning methods. Every subject is interesting!',
      rating: 5,
      avatar: 'https://ui-avatars.com/api/?name=Priya+Patel&background=059669&color=fff&size=60'
    },
    {
      name: 'Dr. Suresh Kumar',
      role: 'Alumni Parent',
      content: 'Best school in the region with excellent infrastructure and caring teachers.',
      rating: 5,
      avatar: 'https://ui-avatars.com/api/?name=Suresh+Kumar&background=7C3AED&color=fff&size=60'
    }
  ];

// 🏆 TOPPERS DATA
const toppersByBatch = {
  '2025-26': {
    batch: '8th Batch',
    year: '2025-26',
    toppers: [
      {
        name: 'Ganesh Basvaraj',
        regNo: '2026020113',
        marks: '620/625',
        percentage: '99.20%',
        stateRank: '6th',
        rank: '1st Rank',
        image: '/images/toppers/ganesh-basvaraj.jpeg',
        color: 'from-yellow-400 to-yellow-600'
      },
      {
        name: 'Vedant Udhav',
        regNo: '2026078210',
        marks: '618/625',
        percentage: '98.88%',
        stateRank: '8th',
        rank: '2nd Rank',
        image: '/images/toppers/vedant-udhav.jpeg',
        color: 'from-gray-400 to-gray-600'
      },
      {
        name: 'Bhagyalaxmi Vishwanath',
        regNo: '2026050054',
        marks: '616/625',
        percentage: '98.56%',
        stateRank: '10th',
        rank: '3rd Rank',
        image: '/images/toppers/bhagyalaxmi-vishwanath.jpeg',
        color: 'from-orange-400 to-orange-600'
      }
    ]
  },
  '2024-25': {
    batch: '7th Batch',
    year: '2024-25',
    toppers: [
      {
        name: 'Srushti Sanjeevkumar',
        regNo: '2025048849',
        marks: '622/625',
        percentage: '99.52%',
        stateRank: '4th',
        rank: '1st Rank',
        image: '/images/toppers/srushti-sanjeevkumar.jpeg',
        color: 'from-yellow-400 to-yellow-600'
      },
      {
        name: 'Vaishnavi Laxman',
        regNo: '2025017874',
        marks: '621/625',
        percentage: '99.36%',
        stateRank: '5th',
        rank: '2nd Rank',
        image: '/images/toppers/vaishnavi-laxman.jpeg',
        color: 'from-gray-400 to-gray-600'
      },
      {
        name: 'Pratiksha Dayanand',
        regNo: '2025074975',
        marks: '620/625',
        percentage: '99.20%',
        stateRank: '6th',
        rank: '3rd Rank',
        image: '/images/toppers/pratiksha-dayanand.jpeg',
        color: 'from-orange-400 to-orange-600'
      }
    ]
  },
  '2023-24': {
    batch: '6th Batch',
    year: '2023-24',
    toppers: [
      {
        name: 'Sindhu Nandkumar',
        regNo: '2024020056',
        marks: '620/625',
        percentage: '99.20%',
        stateRank: '6th',
        rank: '1st Rank',
        image: '/images/toppers/sindhu-nandkumar.jpeg',
        color: 'from-yellow-400 to-yellow-600'
      },
      {
        name: 'Krupa Chandrashekhar',
        regNo: '2024077326',
        marks: '618/625',
        percentage: '98.88%',
        stateRank: '8th',
        rank: '2nd Rank',
        image: '/images/toppers/krupa-chandrashekar.jpeg',
        color: 'from-gray-400 to-gray-600'
      },
      {
        name: 'Sangamesh Sharnappa',
        regNo: '2024050588',
        marks: '613/625',
        percentage: '98.08%',
        stateRank: '13th',
        rank: '3rd Rank',
        image: '/images/toppers/sangamesh-sharnappa.jpeg',
        color: 'from-orange-400 to-orange-600'
      }
    ]
  },
  '2022-23': {
    batch: '5th Batch',
    year: '2022-23',
    toppers: [
      {
        name: 'Akshita Sharnappa',
        regNo: '2023050829',
        marks: '621/625',
        percentage: '99.36%',
        stateRank: '5th',
        rank: '1st Rank',
        image: '/images/toppers/akshita-sharnappa.jpeg',
        color: 'from-yellow-400 to-yellow-600'
      },
      {
        name: 'Trupti Dileep',
        regNo: '2023050851',
        marks: '611/625',
        percentage: '97.76%',
        stateRank: '15th',
        rank: '2nd Rank',
        image: '/images/toppers/trupti-dileep.jpeg',
        color: 'from-gray-400 to-gray-600'
      },
      {
        name: 'Shivangi Gunderao',
        regNo: '2023019000',
        marks: '609/625',
        percentage: '97.44%',
        stateRank: '17th',
        rank: '3rd Rank',
        image: '/images/toppers/shivangi-gunderao.jpeg',
        color: 'from-orange-400 to-orange-600'
      }
    ]
  }
};



  
  // 🏫 FACILITIES DATA
  const facilities = [
    {
      icon: BuildingLibraryIcon,
      title: 'Modern Library',
      desc: '15,000+ books, digital resources, and quiet reading zones',
      color: 'from-blue-500 to-indigo-600'
    },
    {
      icon: LightBulbIcon,
      title: 'Science Labs',
      desc: 'Fully equipped Physics, Chemistry, and Biology laboratories',
      color: 'from-yellow-500 to-orange-600'
    },
    {
      icon: RocketLaunchIcon,
      title: 'Computer Lab',
      desc: 'Latest computers with high-speed internet and coding classes',
      color: 'from-purple-500 to-pink-600'
    },
    {
      icon: TrophyIcon,
      title: 'Sports Complex',
      desc: 'Cricket, basketball, volleyball courts and indoor games',
      color: 'from-green-500 to-teal-600'
    },
    {
      icon: HeartIcon,
      title: 'Health Care',
      desc: 'Medical room with trained nurse and regular health checkups',
      color: 'from-red-500 to-pink-600'
    },
    {
      icon: ShieldCheckIcon,
      title: 'Safe Campus',
      desc: 'CCTV surveillance, secure entry, and trained security staff',
      color: 'from-cyan-500 to-blue-600'
    }
  ];

  // 📅 UPCOMING EVENTS DATA
  const events = [
    {
      date: '15',
      month: 'MAR',
      title: 'Annual Sports Day',
      desc: 'Inter-house sports competition with prizes',
      color: 'from-blue-500 to-blue-600'
    },
    {
      date: '22',
      month: 'MAR',
      title: 'Science Exhibition',
      desc: 'Students showcase innovative science projects',
      color: 'from-green-500 to-green-600'
    },
    {
      date: '05',
      month: 'APR',
      title: 'Parent-Teacher Meeting',
      desc: 'Discuss student progress with teachers',
      color: 'from-purple-500 to-purple-600'
    },
    {
      date: '14',
      month: 'APR',
      title: 'Cultural Fest 2026',
      desc: 'Music, dance, and drama performances',
      color: 'from-orange-500 to-orange-600'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* ==================== HERO SECTION ==================== */}
      <section className="relative bg-gradient-to-br from-indigo-900 via-purple-900 to-blue-900 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-10 left-10 w-72 h-72 bg-blue-400 rounded-full animate-pulse"></div>
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-purple-400 rounded-full animate-pulse delay-1000"></div>
        </div>

        <div className="relative container mx-auto px-4 py-20 md:py-28">
          <div className="max-w-5xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-lg rounded-full px-6 py-2 mb-6 border border-white/20">
              <span className="relative flex h-3 w-3">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
              </span>
              <span className="text-sm font-medium">🏆 Excellence in Education</span>
            </div>

            <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
              <span className="bg-gradient-to-r from-yellow-300 via-yellow-400 to-yellow-500 bg-clip-text text-transparent">
                Vidya Bharati
              </span>
              <span className="text-yellow-300">,</span>
              <span className="text-white"> Public School Bhalki </span>
            </h1>

            <div className="inline-block bg-white/10 backdrop-blur-lg rounded-2xl px-8 py-4 mb-6 border border-white/20">
              <p className="text-3xl md:text-4xl text-yellow-300 font-medium">
                ವಿದ್ಯಾ ಪರಮ ಭೂಷಣಮ್
              </p>
              <p className="text-xs text-blue-200 mt-1">"Knowledge is the highest ornament"</p>
            </div>

            <p className="text-xl md:text-2xl text-blue-200 mb-4 font-light max-w-3xl mx-auto">
              Empowering minds, shaping futures since 2006
            </p>

            <div className="flex flex-wrap justify-center gap-4 mt-8">
              <Link to="/admissions" className="group bg-gradient-to-r from-yellow-400 to-yellow-500 text-gray-900 px-8 py-3 rounded-full font-bold hover:shadow-2xl transition-all duration-300 flex items-center gap-2 hover:scale-105">
                Apply Now
                <ChevronRightIcon className="h-5 w-5 group-hover:translate-x-1 transition" />
              </Link>
              <Link to="/about" className="bg-white/20 backdrop-blur-sm border-2 border-white/30 text-white px-8 py-3 rounded-full font-semibold hover:bg-white/30 transition">
                Explore Campus
              </Link>
            </div>
          </div>
        </div>

        <div className="relative bg-black/30 backdrop-blur-sm py-6 border-t border-white/10">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {stats.map((stat, index) => (
                <div key={index} className="text-center group">
                  <div className={`inline-block p-3 rounded-2xl bg-gradient-to-r ${stat.color} mb-2 group-hover:scale-110 transition`}>
                    <stat.icon className="h-6 w-6 text-white" />
                  </div>
                  <div className="text-2xl md:text-3xl font-bold text-white">{stat.value}</div>
                  <div className="text-sm text-blue-200">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ==================== NOTICE BOARD ==================== */}
      {showNotice && (
        <section className="bg-gradient-to-r from-yellow-50 via-orange-50 to-yellow-50 border-b-2 border-yellow-200 py-3 shadow-sm">
          <div className="container mx-auto px-4">
            <div className="flex flex-col md:flex-row justify-between items-center gap-3">
              <div className="flex items-center gap-3">
                <span className="bg-gradient-to-r from-red-500 to-red-600 text-white text-xs font-bold px-4 py-1.5 rounded-full animate-pulse shadow-lg">
                  📢 NEW
                </span>
                <p className="text-sm md:text-base text-gray-700">
                  <span className="font-bold text-red-600">Admissions Open for 2026-27!</span>
                </p>
              </div>
              <div className="flex items-center gap-4">
                <Link to="/admissions" className="text-sm bg-red-600 text-white px-4 py-1.5 rounded-full font-semibold hover:bg-red-700 transition">
                  Apply Now
                </Link>
                <button onClick={() => setShowNotice(false)} className="text-gray-400 hover:text-gray-600 transition text-sm">
                  ✕ Close
                </button>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* ==================== FEATURES ==================== */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <span className="text-sm font-bold text-blue-600 uppercase tracking-wider bg-blue-50 px-4 py-1 rounded-full">Why Choose Us</span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mt-3 mb-4">
              Excellence in <span className="text-blue-600">Education</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-purple-600 mx-auto rounded-full"></div>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {features.map((feature, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-md hover:shadow-xl transition p-6 text-center border border-gray-100 hover:-translate-y-2">
                <div className={`inline-block p-4 rounded-2xl bg-gradient-to-r ${feature.color} mb-4`}>
                  <feature.icon className="h-8 w-8 text-white" />
                </div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">{feature.title}</h3>
                <p className="text-gray-600 text-sm">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ==================== TOPPERS / ACHIEVERS SECTION ==================== */}
      <section className="py-20 bg-gradient-to-br from-indigo-900 via-purple-900 to-blue-900 relative overflow-hidden">
        {/* Decorative background */}
        <div className="absolute top-0 left-0 w-96 h-96 bg-yellow-500 rounded-full opacity-10 blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-orange-500 rounded-full opacity-10 blur-3xl"></div>

        <div className="relative container mx-auto px-4">
          {/* Header */}
          <div className="text-center mb-14">
            <span className="text-xs font-bold text-yellow-300 uppercase tracking-widest bg-yellow-400/10 px-5 py-2 rounded-full inline-flex items-center gap-2 border border-yellow-400/30">
              <SparklesIcon className="h-4 w-4" />
              Wall of Fame
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-white mt-5 mb-4">
              Our <span className="bg-gradient-to-r from-yellow-300 via-yellow-400 to-orange-400 bg-clip-text text-transparent">Star Achievers</span>
            </h2>
            <p className="text-blue-200 text-lg max-w-2xl mx-auto">
              12 brilliant students • 4 batches • State Rank Holders
            </p>
            <div className="w-32 h-1 bg-gradient-to-r from-yellow-400 to-orange-500 mx-auto rounded-full mt-6"></div>
          </div>

          {/* All Toppers - Grouped by Batch */}
          {Object.entries(toppersByBatch).map(([batchKey, batchData]) => (
            <div key={batchKey} className="mb-14 last:mb-0">
              {/* Batch Header */}
              <div className="flex items-center justify-center gap-4 mb-8">
                <div className="h-px flex-1 bg-gradient-to-r from-transparent via-yellow-400/40 to-transparent max-w-xs"></div>
                <div className="flex items-center gap-3 px-6 py-2.5 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full shadow-lg">
                  <TrophyIcon className="h-5 w-5 text-white" />
                  <span className="font-bold text-white text-sm md:text-base">
                    {batchData.batch} • {batchData.year}
                  </span>
                </div>
                <div className="h-px flex-1 bg-gradient-to-r from-transparent via-yellow-400/40 to-transparent max-w-xs"></div>
              </div>

              {/* 3 Students per Batch - Passport Style Cards */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
                {batchData.toppers.map((topper, index) => (
                  <div
                    key={index}
                    className="group bg-white rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 border border-white/20"
                  >
                    {/* Top color bar */}
                    <div className={`h-2 bg-gradient-to-r ${topper.color}`}></div>

                    {/* Main content */}
                    <div className="p-5">
                      <div className="flex gap-4 items-start">
                        {/* Passport Photo - Small */}
                        <div className="flex-shrink-0 relative">
                          <img
                            src={topper.image}
                            alt={topper.name}
                            className="w-20 h-24 rounded-lg object-cover object-top border-2 border-gray-200 shadow-md bg-gray-100"
                            onError={(e) => {
                              e.target.onerror = null;
                              let bgColor = '4F46E5';
                              if (topper.rank === '1st Rank') bgColor = 'F59E0B';
                              if (topper.rank === '2nd Rank') bgColor = '6B7280';
                              if (topper.rank === '3rd Rank') bgColor = 'EA580C';
                              e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(topper.name)}&background=${bgColor}&color=fff&size=200&bold=true`;
                            }}
                          />
                          {/* Rank Badge on photo */}
                          <div className={`absolute -top-2 -right-2 bg-gradient-to-r ${topper.color} text-white text-[10px] font-bold px-2 py-1 rounded-full shadow-lg flex items-center gap-0.5`}>
                            <TrophyIcon className="h-2.5 w-2.5" />
                            {topper.rank.replace(' Rank', '')}
                          </div>
                        </div>

                        {/* Details - Right side */}
                        <div className="flex-1 min-w-0">
                          <h3 className="text-base font-bold text-gray-800 truncate mb-1">
                            {topper.name}
                          </h3>
                          <p className="text-[10px] text-gray-400 font-mono mb-3 truncate">
                            Reg: {topper.regNo}
                          </p>

                          {/* Percentage + Marks inline */}
                          <div className="flex items-baseline gap-2 mb-2">
                            <span className="text-2xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
                              {topper.percentage}
                            </span>
                            <span className="text-xs text-gray-500 font-semibold">
                              {topper.marks}
                            </span>
                          </div>

                          {/* State Rank pill */}
                          <div className="inline-flex items-center gap-1.5 bg-gradient-to-r from-red-500 to-orange-500 text-white px-3 py-1 rounded-full shadow-sm">
                            <span className="text-[10px] font-semibold">🏅 State Rank</span>
                            <span className="text-sm font-bold">{topper.stateRank}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Bottom accent line */}
                    <div className={`h-1 bg-gradient-to-r ${topper.color} transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left`}></div>
                  </div>
                ))}
              </div>
            </div>
          ))}

          {/* View All Button */}
          <div className="text-center mt-14">
            <Link
              to="/achievements"
              className="group inline-flex items-center gap-3 bg-gradient-to-r from-yellow-400 via-yellow-500 to-orange-500 text-gray-900 px-10 py-4 rounded-full font-bold shadow-2xl hover:shadow-[0_20px_50px_-10px_rgba(251,191,36,0.8)] transition-all duration-300 hover:scale-105"
            >
              <TrophyIcon className="h-6 w-6 group-hover:rotate-12 transition-transform" />
              View Complete Achievements
              <ChevronRightIcon className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </section>

      {/* ==================== FACILITIES ==================== */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <span className="text-sm font-bold text-purple-600 uppercase tracking-wider bg-purple-50 px-4 py-1 rounded-full">World-Class Facilities</span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mt-3 mb-4">
              Campus <span className="text-purple-600">Infrastructure</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-purple-600 to-pink-600 mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {facilities.map((facility, index) => (
              <div
                key={index}
                className="group bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 p-6 border border-gray-100 hover:-translate-y-1"
              >
                <div className={`inline-block p-4 rounded-2xl bg-gradient-to-r ${facility.color} mb-4 group-hover:scale-110 transition`}>
                  <facility.icon className="h-7 w-7 text-white" />
                </div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">{facility.title}</h3>
                <p className="text-gray-600 text-sm">{facility.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ==================== TESTIMONIALS ==================== */}
      <section className="py-16 bg-gradient-to-br from-blue-50 to-indigo-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <span className="text-sm font-bold text-indigo-600 uppercase tracking-wider bg-indigo-50 px-4 py-1 rounded-full">Testimonials</span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mt-3">
              What <span className="text-indigo-600">People Say</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-indigo-600 to-blue-600 mx-auto rounded-full mt-4"></div>
          </div>
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
              <div className="flex flex-col md:flex-row items-center gap-8">
                <img src={testimonials[currentTestimonial].avatar} alt={testimonials[currentTestimonial].name} className="w-20 h-20 rounded-full border-4 border-indigo-100 shadow-lg" />
                <div className="flex-1 text-center md:text-left">
                  <div className="flex justify-center md:justify-start text-yellow-400 mb-2">
                    {[...Array(5)].map((_, i) => (<StarSolidIcon key={i} className="h-5 w-5" />))}
                  </div>
                  <p className="text-gray-700 text-lg italic">"{testimonials[currentTestimonial].content}"</p>
                  <p className="font-bold text-gray-800 mt-4">{testimonials[currentTestimonial].name}</p>
                  <p className="text-sm text-gray-500">{testimonials[currentTestimonial].role}</p>
                </div>
              </div>
              <div className="flex justify-center gap-2 mt-6">
                {testimonials.map((_, index) => (
                  <button key={index} onClick={() => setCurrentTestimonial(index)} 
                    className={`w-3 h-3 rounded-full transition ${currentTestimonial === index ? 'bg-indigo-600 w-8' : 'bg-gray-300'}`} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ==================== UPCOMING EVENTS ==================== */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <span className="text-sm font-bold text-green-600 uppercase tracking-wider bg-green-50 px-4 py-1 rounded-full">Mark Your Calendar</span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mt-3 mb-4">
              Upcoming <span className="text-green-600">Events</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-green-600 to-teal-600 mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {events.map((event, index) => (
              <div
                key={index}
                className="group bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100 hover:-translate-y-1"
              >
                <div className={`bg-gradient-to-r ${event.color} p-4 text-white relative`}>
                  <div className="flex items-center gap-3">
                    <div className="bg-white/20 backdrop-blur-sm rounded-xl p-2 text-center min-w-[60px]">
                      <div className="text-2xl font-bold">{event.date}</div>
                      <div className="text-xs font-semibold">{event.month}</div>
                    </div>
                    <div className="flex-1">
                      <ClockIcon className="h-4 w-4 opacity-80" />
                    </div>
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">{event.title}</h3>
                  <p className="text-gray-600 text-sm mb-3">{event.desc}</p>
                  <Link to="/events" className="text-sm font-semibold text-indigo-600 hover:text-indigo-800 inline-flex items-center gap-1 group-hover:gap-2 transition-all">
                    Learn More
                    <ChevronRightIcon className="h-4 w-4" />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ==================== CTA ==================== */}
      <section className="relative py-20 bg-gradient-to-r from-blue-900 via-indigo-900 to-purple-900 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-64 h-64 bg-yellow-400 rounded-full"></div>
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-purple-400 rounded-full"></div>
        </div>
        <div className="relative container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Ready to Join <span className="text-yellow-300">Vidya Bharati</span>?
          </h2>
          <p className="text-lg text-blue-200 mb-8 max-w-2xl mx-auto">
            Give your child the best education and a bright future. Applications are now open for the academic year 2026-27.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/admissions" className="group bg-gradient-to-r from-yellow-400 to-yellow-500 text-gray-900 px-8 py-3 rounded-full font-bold hover:shadow-2xl transition flex items-center gap-2">
              Apply for Admission
              <ChevronRightIcon className="h-5 w-5 group-hover:translate-x-1 transition" />
            </Link>
            <Link to="/contact" className="bg-white/20 backdrop-blur-sm border-2 border-white/30 text-white px-8 py-3 rounded-full font-semibold hover:bg-white/30 transition">
              Contact Us
            </Link>
          </div>

          {/* Contact Info Bar */}
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
            <div className="flex items-center justify-center gap-3 bg-white/10 backdrop-blur-sm rounded-xl p-4">
              <MapPinIcon className="h-5 w-5 text-yellow-300" />
              <span className="text-sm">Bhalki, Karnataka</span>
            </div>
            <div className="flex items-center justify-center gap-3 bg-white/10 backdrop-blur-sm rounded-xl p-4">
              <PhoneIcon className="h-5 w-5 text-yellow-300" />
              <span className="text-sm">+91 98765 43210</span>
            </div>
            <div className="flex items-center justify-center gap-3 bg-white/10 backdrop-blur-sm rounded-xl p-4">
              <EnvelopeIcon className="h-5 w-5 text-yellow-300" />
              <span className="text-sm">info@vbps.edu.in</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;